import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { useCallback } from "react";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header
 */

type Props = {
  tipoPesquisa: number,
  motivoAfastamento: string,
  status: number,
  onTipoPesquisaChange: (novoTipoPesquisa: number) => void,
  onMotivoAfastamentoChange: (novoMotivoAfastamento: string) => void,
  onStatusChange: (novoStatus: number) => void,
};

export const Header = ({
  tipoPesquisa,
  motivoAfastamento,
  status,
  onTipoPesquisaChange,
  onMotivoAfastamentoChange,
  onStatusChange,
}: Props) => {
  const handleTipoPesquisaChange = useCallback((e: SelectChangeEvent<number>) => {
    onTipoPesquisaChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)
  }, [onTipoPesquisaChange]);

  const handleStatusChange = useCallback((e: SelectChangeEvent<number>) => {
    onStatusChange(typeof e.target.value === "string" ? parseInt(e.target.value) : e.target.value)
  }, [onStatusChange]);

  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 grid-flow-row-dense">
            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
              <FormControl size="small" sx={{ width: "275px" }}>
                <InputLabel id="modulo-dashboard" size="small">Pesquisar por</InputLabel>
                <Select
                  size="small"
                  labelId="modulo-dashboard"
                  label="Pesquisar por"
                  value={tipoPesquisa}
                  onChange={handleTipoPesquisaChange}>
                  <MenuItem value={1}>Motivo Afastamento</MenuItem>
                </Select>
              </FormControl>

              <div className="w-full">
                <DefaultInput
                  label="Pesquisar"
                  name="search_by_motivo_demissao"
                  value={motivoAfastamento}
                  onChangeValue={onMotivoAfastamentoChange} />
              </div>
            </div>

            <div className="flex col-span-1 md:col-span-2 lg:col-span-1 gap-1">
              <FormControl size="small" fullWidth>
                <InputLabel id="modulo-dashboard"></InputLabel>
                <Select
                  labelId="modulo-dashboard"
                  label=""
                  value={status}
                  onChange={handleStatusChange}>
                  <MenuItem value={1}>Todos</MenuItem>
                  <MenuItem value={2}>Ativos</MenuItem>
                  <MenuItem value={3}>Inativos</MenuItem>
                </Select>
              </FormControl>
            </div>
          </div>
        </div>
      </CascateList>
    </>
  );
}